import { Injectable } from '@angular/core';
import { webobjecttypeMock } from '../DataStore/Mock/webobjecttype-mock';
import { WebObjectTypeModel } from '../Models/web-object-type-model';
import { WebObjectModel } from '../Models/web-object-model';

@Injectable({
  providedIn: 'root'
})
export class WebObjectTypeService {

  constructor() { }
  
  public  getItems(){
    return webobjecttypeMock.getItems();
  }
  public  findByObjectId(id: string):WebObjectTypeModel{
    return webobjecttypeMock.findByObjectId(id);
  }

  public  static findById(id:string):WebObjectTypeModel{
      return webobjecttypeMock.findById(id);
  }

  public  getObjects():WebObjectTypeModel[]{
    return webobjecttypeMock.getItems();
  }

  public getObjectsByPageObject(model:WebObjectModel): WebObjectTypeModel[]{
    var ids: string;
    // ids = model.type;
    // if(ids == undefined) return null;
    //
     let objects = [];
    for(let i = 0; i < ids.length; i++){
      objects.push(this.findByObjectId(ids[i]));
    }
    return objects;
  }
}
